// components/common/CommonButton.tsx
"use client";

import React from "react";
import { Button, buttonVariants } from "@/components/ui/button"; // adjust path if needed
import type { VariantProps } from "class-variance-authority";

interface CommonButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  children: React.ReactNode;
  asChild?: boolean;
}

const CommonButton: React.FC<CommonButtonProps> = ({
  children,
  variant = "default",
  size = "default",
  className = "",
  asChild = false,
  ...props
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      asChild={asChild}
      className={className}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CommonButton;
